import React from 'react';
import { i18n } from 'core/i18n';
const { formatText } = i18n;

const BlockedModal = ({ onAccept }) => {
    return (
        <React.Fragment>
            <br />
            <h3 className="font-heading3">{formatText('identity-videoCallNoVerifyTitle')}</h3>
            <div className="video-screen__modal-body-content">
                <p className="video-screen__modal-body-text font-paragraph2">
                    {formatText('identity-videoCallNoVerifyText')}
                </p>
            </div>
            <div className="video-screen__modal-buttons">
                <button className="form__button form__button-secondary" onClick={onAccept}>
                    {formatText('button-understood')}
                </button>
            </div>
        </React.Fragment>
    );
};

export default BlockedModal;
